// extracted by mini-css-extract-plugin
module.exports = {"slideContainer":"Lightbox_slideContainer__jEFFL","dots":"Lightbox_dots__oKkJq"};